import {Component, ElementRef, EventEmitter, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet, NavigationEnd} from '@angular/router';
import {SwitchBoard} from "./services/SwitchBoard";
import {LoadingService} from "./services/LoadingService";
import {LoginService} from "./services/Login.service";
import {ToastService} from "./services/Toast.service";
import {PageTitleService} from "./services/PageTitle";
import {NumeralService} from "./services/Numeral.service";
import {CacheService} from "./services/cache.service";
import {StateService} from "./services/StateService";
import {LogoService} from "./services/LogoService";
import {Session} from "./services/Session";
import {TaxPlanningService} from "./tpiq-services/tax-planning.service";
import {UrlService} from "./services/UrlService";
import {environment} from "../environments/environment";
import {TOAST_TYPE} from "./constants/Tpiq.constants";
import {UserModel} from "./models/user.model";
import {retry, takeUntil} from "rxjs/operators";
import {CommonModule} from "@angular/common";
import {GlobalFloatingWindowComponent} from "./global-floating-window/global-floating-window.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {HeaderComponent} from "./header/header.component";
import {WindowsComponent} from "./windows/windows.component";
import {TpiqChatBotComponent} from "./tpiq-chat-bot/tpiq-chat-bot.component";
import {CustomerSidebarComponent} from "./customer-app/customer-sidebar/customer-sidebar.component";
import {CustomerHeaderComponent} from "./customer-app/customer-header/customer-header.component";
import './utils-lib/froala-plugins';

import {filter} from 'rxjs/operators';
import {BasicPlanLimitService} from './tpiq-services/basic-plan-limit.service';
import {BasicPlanLimit} from './models/basic-plan-limit.model';
import {LockedJaineComponent} from './basic-plan-limit/locked-jaine.component';
import {canOpenPlatformPicker} from './login/post-login-destination';

declare let jQuery: any;
declare let _: any;
declare let window: any;
declare let pendo: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, GlobalFloatingWindowComponent, SidebarComponent, HeaderComponent, WindowsComponent,
  TpiqChatBotComponent, CustomerHeaderComponent, CustomerSidebarComponent, LockedJaineComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
   encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  isSideMenuExpanded = false;
  hasLoggedIn = false;
  // True when the active route should render full-bleed (no sidebar, top-bar,
  // chat widget). Currently /choose-platform — the post-login interstitial.
  isChromelessRoute = false;
  loginSubscription = null;
  logoutSubscription = null;
  largeSidebarSubscription = null;
  user: UserModel;
  toasts: Array<any>;
  toastClass = '';
  confirmClass = '';
  isOffCanvasMenuExpanded = false;
  mainCanvasCss = {
    'main-canvas': true,
    expanded: false,
    shrinkRight: false,
    'more-expanded': false,
    'tp-firm-expanded': false
  };
  titleCSS = {
    'expanded-top-nav-arrows': false,
    'shrink-top-nav-arrows': true,
    'more-expanded-top-nav-arrows': false,
    'header-taxplan-logo': true
  };
  sub: any;
  isOverlay = false;
  isLoading = false;
  pageTitle = '';
  currentEnvironment: any;
  @ViewChild('title') title: ElementRef;
  pageThemeSubscriber: any;
  theme = 'wallTheme';
  expanded = false;
  orgName = '';
  smallLogo = './images/logo.png';
  refreshInterval: any;
  billingDetailsSubscriber: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('appwindows') appWindows: ElementRef;
  searchOptions: any;
  toggle = false;
  largeSideMenu = false;
  isCustomer = false;
  taxPlanningTerms: any;
  subscriptionStatus = '';
  onboardStatus: any;
  // CU-868kpjgur: the constructor sets this when it finds and clears a
  // half-written session. ngOnInit reads it, and then tells the user why the
  // app returned to /login.
  hadPartialSession = false;
  private routerSubscription: any;
  basicPlanLimit?: BasicPlanLimit;
  // True when the header logo opens the platform picker (Tax Projections access).
  logoOpensPicker = false;
  basicPlanLimitLoaded = false;
  basicPlanLimitLoadFailed = false;
  jaineAllowedOnError = false;
  basicPlanLimitRetryVisible = false;
  private readonly entitlementTaxYear = new Date().getFullYear();
  private entitlementLoadSequence = 0;
  private basicPlanLimitKey?: string;

  @ViewChild(WindowsComponent) winndowsComponent;

  constructor(private _router: Router, private route: ActivatedRoute, private toastService: ToastService,
              private titleService: PageTitleService, private loadingService: LoadingService, private loginService: LoginService, private _toastService: ToastService,
              private numeralService: NumeralService, private cacheService: CacheService, private stateService: StateService,
              private logoService: LogoService, private switchBoard: SwitchBoard,
              private taxPlanningService: TaxPlanningService,
              private basicPlanLimits: BasicPlanLimitService) {
    const self = this;
    this.currentEnvironment = environment;
    UrlService.setUrls(this.currentEnvironment);
    // Initialize chromeless-route flag from the current URL BEFORE anything
    // login-driven renders. setupPendoRouterTracking() (called later from
    // the onLogin subscription) keeps it in sync via NavigationEnd, but on
    // a direct load / refresh of /choose-platform that subscription hasn't
    // attached yet and the chrome would flash for a frame.
    this.isChromelessRoute = this._router.url.startsWith('/choose-platform');
    // ConfigService.loadingConfig(this.currentEnvironment);
    this.handleLogos();
    this.cacheService.initCache();
    if (window.location.href.includes('token')){
      Session.destroy();
    }else {
      // CU-868kpjgur: clear a half-written session before anything reads it.
      //
      // A login can write the credential and not write `user`. The code below
      // then raised a TypeError in this constructor. The error rejected
      // bootstrapApplication (main.ts:6) and left app-root empty.
      //
      // The error happened before routing. So the user could not open /login
      // and try again. Only clearing the site data helped.
      //
      // The app now drops the unusable session and asks the user to sign in.
      this.hadPartialSession = Session.hasPartialSession();
      if (this.hadPartialSession) {
        Session.destroy();
      }
      if (Session.hasSession()) {
        const user: any = Session.getUser();
        this.user = user;
        const status: any = user.onboardingStatus;
        this.onboardStatus = (status) ? status : 'Done';
        this.hasLoggedIn = this.onboardStatus === 'Done';
        const accessInfo: any = Session.getUserAccessInfo();
        this.subscriptionStatus = (accessInfo) ? accessInfo.subscriptionStatus : '';
        this.refreshLogoAccess();
        // the public taxpayer form is unguarded on purpose; a signed-in viewer
        // (firm user, or a prior portal session in this browser) must still see
        // it rather than being redirected to their dashboard (CU-868kg6qux)
        if (!window.location.href.includes('questionnaire-form')) {
          this.goToDefaultPage();
        }
      } else {
        this.hasLoggedIn = false;
        if (!window.location.href.includes('resetpassword')
          && !window.location.href.includes('signup')
          && !window.location.href.includes('auto-login')
          && !window.location.href.includes('10-days-tax-plan-challenge')
          // external taxpayer questionnaire form — public, no login (CU-868kg6qux)
          && !window.location.href.includes('questionnaire-form')) {
          this.goToDefaultPage();
        }
      }
    }

    this.toasts = [];
    this.toastClass = '';
    this.billingDetailsSubscriber = this.switchBoard.onBillingDetailsApproved.subscribe(obj => {
      const user: any = Session.getUser();
      this.switchBoard.onLogin.next(Session.get('user'));
      if (user.isCustomer){
        this._router.navigate(['tax-planning/customer/dashboard']);
      }else {
        const base = this;
        const homeobj = {
          type: 'taxPlanningHome',
          route: 'taxPlanning',
          clearAllStates: true
        };
        setTimeout(() => {
          base.switchBoard.onWallTpiqSwitch.next(homeobj);
        });
      }
    });
    this.switchBoard.onNewToast.subscribe(toast => this.addToast(toast));
    // jQuery('.loading-initial-cont').hide();
    // jQuery('.loading-cont').show();
    this.switchBoard.onSideBarExpand.subscribe(flag => {
      this.isSideMenuExpanded = flag;
    });
    this.switchBoard.onTpFirmSideBarWidthChange.subscribe(obj => {
      this.mainCanvasCss['tp-firm-expanded'] = true;
    });
    this.switchBoard.onLoadingWheel.subscribe(toggle => this.toggleLoader(toggle));
    this.switchBoard.onPageChange.subscribe(title => this.updatePageTitle(title));
    this.pageThemeSubscriber = this.switchBoard.onThemeChange.subscribe(theme => this.updatePageTheme(theme));

    this.switchBoard.toggleAdvanceSearch.subscribe(options => {
      this.toggle = false;
      this.searchOptions = options;
      setTimeout(() => {
        this.toggle = true;
      });
    } );

    this.switchBoard.onUserAccess.subscribe(options => {
      const accessInfo: any = Session.getUserAccessInfo();
      this.subscriptionStatus = (accessInfo) ? accessInfo.subscriptionStatus : '';
      this.refreshLogoAccess();
    } );

    this.switchBoard.onToggleFeedback.pipe(takeUntil(this.destroy$))
      .subscribe(obj => {
      });
    this.switchBoard.onCustomerLogin.subscribe(obj => this.toggleCSS());
    this.switchBoard.onUserOnboard.pipe(takeUntil(this.destroy$))
      .subscribe(obj => {
        // CU-868kpjgur: this line read a null `user`, like the constructor
        // did. It runs later, so it cannot blank the app. It did stop this
        // subscription without a message.
        let status: any = Session.getUser()?.onboardingStatus;
        this.onboardStatus = (status) ? status : 'Done';
        this.hasLoggedIn = this.onboardStatus === 'Done';
        this.refreshLogoAccess();
      });

    this.switchBoard.onLogosReady.subscribe(logoObj => {
      if (logoObj.faviconUrl) {
        this.smallLogo = logoObj.faviconUrl;
      }
    });
  }

  // CU-868kcbz08 (unified-session epic): the beforeunload session teardown
  // was REMOVED. It called loggedOut() (Session.destroy → localStorage.clear)
  // on tab close for most routes, so reopening always forced a fresh login.
  // For a shared, persistent session that is the wrong behavior — closing a
  // tab must not end the session. localStorage naturally persists across tab
  // close; the 12h sliding TTL (and, post-P2.2, the tpiq_session cookie) still
  // bound the session's lifetime. Single logout (P2.4) remains the explicit
  // end-everywhere path.

  showEscalation(event){
    console.log(event);
    console.log(this.taxPlanningService.getUserFirstLogin());
  }

  handleLogos(){
    this.orgName = window.location.href.split('/')[2].split('.')[0];
    this.logoService.getOrgLogos(this.orgName).subscribe(response => {
      this.logoService.setLogoUrls(response);
      this.switchBoard.onLogosReady.next(response);
      if (response.faviconUrl){
        jQuery('#favicon').attr('href', response.faviconUrl);
        this.smallLogo = response.faviconUrl;
      } else  if (this.orgName === 'stag-app' || this.orgName === 'app') {
        let logoObj = {
          faviconUrl: 'https://static.taxplaniq.com/futurefirm/favicon_new.png',
          loginLogoUrl: 'https://static.taxplaniq.com/test-taxplaniq/new_tpiq_logo.png'
        };
        this.logoService.setLogoUrls(logoObj);
        let tpiqFavLogo = 'https://static.taxplaniq.com/futurefirm/favicon_new.png';
        jQuery('#favicon').attr('href', tpiqFavLogo);
        this.smallLogo = tpiqFavLogo;
      }
    }, error => {
    });
  }

  refreshToken(){
    const base = this;
    // CU-868m49jqy: never stack timers. loggedIn() calls this on every onLogin
    // emission (8 emit sites), and ngOnInit starts it too on a restored
    // session. Without this clear, each extra call leaked a timer whose handle
    // was immediately overwritten and could never be cleared.
    clearInterval(this.refreshInterval);
    this.refreshInterval = setInterval(() => {
      const data = {
        token: Session.getToken(),
        refreshToken: Session.getRefreshToken()
      };
      base.loginService.refreshToken(data).subscribe(response  => {base.updateToken(response); }, error => {
        base.switchBoard.onNewToast.next({
          toastId: Math.floor(Math.random() * 1000),
          type: 'info',
          message: 'Your session has expired. Redirecting to login...',
          toastClass: 'toast-info',
          duration: 2000
        });
        setTimeout(() => {
          base.switchBoard.onLogOut.next({});
        }, 1500);
      });
    }, 12 * 60 * 1000); // CU-868kcbyxf: was 15 min == the future 15-min token TTL (P3.4) - equal interval left a boundary window where exp-enforcing endpoints 401
  }

  updateToken(data){
    Session.removeToken();
    Session.setToken(data.token);
    // Same guard as requestInterceptor.renewAndRetry (claude[bot], PR #763).
    // Session.setRefreshToken is a bare localStorage.setItem, so an absent
    // value persists the STRING "undefined" - truthy, and then sent as the
    // refresh token on the next cycle. This timer now runs on every restored
    // session, so the path is routine rather than rare.
    if (data.refreshToken) {
      Session.setRefreshToken(data.refreshToken);
    }
  }

  handleError(error){
    this.loadingService.triggerLoadingEvent(false);
  }

  addToast(toast){
    const self = this;
    const defaultDuration = 1000; // previous default wait time
    const duration = toast.duration ?? defaultDuration;
    if (toast.type === TOAST_TYPE.confirm){
      this.confirmClass = 'confirm-bg';
    }
    this.toasts.push(toast);
    setTimeout(() => {
      if (toast.type !== TOAST_TYPE.confirm) {
        toast.toastClass += ' fadeout';
        setTimeout(() => {
          self.removeToast(toast.toastId);
        }, 300);
      }
    }, duration);
  }

  removeToast(toastId){
    const self = this;
    const index = _.findIndex(self.toasts, (t) => {
      return t.toastId === toastId;
    });
    self.toasts.splice(index, 1);
  }
  confirm(ev, toast){
    if (ev){
      ev.stopPropagation();
    }
    this.switchBoard.onToastConfirm.next(toast);
    this.removeToast(toast.toastId);
    this.confirmClass = '';
  }
  cancel(ev, toast){
    if (ev){
      ev.stopPropagation();
    }
    this.removeToast(toast.toastId);
    this.confirmClass = '';
  }
  error(toast){
    this.removeToast(toast.toastId);
  }

  loggedIn(user: UserModel) {
    this.user = user;
    this.onboardStatus = (user.onboardingStatus) ? user.onboardingStatus : 'Done';
    this.isCustomer = user.isCustomer;
    this.hasLoggedIn = true;
    this.refreshLogoAccess();
    this.loadBasicPlanLimit(true);
    this.refreshToken();
  }

  loggedOut() {
    // CU-868kcbz0y (single logout, unified-session epic): best-effort revoke
    // of the shared tpiq_session server-side BEFORE wiping local state - ends
    // the user's projections sessions too (always-both policy). fetch with
    // keepalive survives the location.replace below; credentials carries the
    // HttpOnly cookie (same-site for *.taxplaniq.com hosts). Failures are
    // ignored - local logout must never block on the network.
    try {
      const javaBase = UrlService.getBaseUrl('JAVA');
      fetch(javaBase + '/TaxPlanningServices/session/logout', {
        method: 'POST', credentials: 'include', keepalive: true
      }).catch(() => {});
    } catch (e) { /* ignore - never block logout */ }
    Session.destroy();
    clearInterval(this.refreshInterval);
    this.theme = 'wallTheme';
    this.loadingService.triggerLoadingEvent(true);
    document.cookie = 'wall=;path=/;domain=' + this.orgName + '.taxplaniq.com';
    window.location.replace('login');
    this.hasLoggedIn = false;
  }

  ngOnInit() {
    this.loginSubscription = this.switchBoard.onLogin.subscribe(user => {
      this.loggedIn(user);
      this.initializePendo();
      this.setupPendoRouterTracking();
    });
    this.logoutSubscription = this.switchBoard.onLogOut.subscribe(status => {
      this.loggedOut();
    });

    // CU-868m49jqy: start the token refresh timer on a restored session.
    // On a reload, a new tab, or a deep link the CONSTRUCTOR calls
    // goToDefaultPage(), which emits onLogin before the subscription above
    // exists. onLogin is a plain Subject, so that emission is dropped,
    // loggedIn() never runs, and the timer never started. The 15-minute access
    // token then expired and the interceptor signed the user out.
    if (Session.hasSession()) {
      this.refreshToken();
      this.loadBasicPlanLimit();
    }

    this.basicPlanLimits.invalidated$.pipe(takeUntil(this.destroy$)).subscribe(change => {
      if ((!change.orgId || change.orgId === Session.getOrg()) &&
          (!change.taxYear || change.taxYear === this.entitlementTaxYear)) {
        this.loadBasicPlanLimit();
      }
    });

    // CU-868kpjgur: tell the user why the app returned to the login form.
    //
    // The constructor cleared the broken session. goToDefaultPage() uses the
    // Router and does not reload the page. So the message stays on screen.
    //
    // This waits one tick, because this component renders the message list.
    if (this.hadPartialSession) {
      setTimeout(() => {
        this.toastService.pop(TOAST_TYPE.info, 'Please sign in again.', null, 5000);
      });
    }

    this.largeSidebarSubscription = this.switchBoard.onShowLargeSidebar.subscribe(status => {
      this.largeSideMenu = status.hasTeams;
    });
    jQuery(document).ready(() => {
      jQuery(document).foundation();
    });
  }

  private loadBasicPlanLimit(forceRefresh = false): void {
    const loadSequence = ++this.entitlementLoadSequence;
    const user = Session.getUser();
    const org = Session.getOrg();
    if (!user?.id || !org || user.isCustomer) {
      this.basicPlanLimitKey = undefined;
      this.basicPlanLimitLoaded = true;
      this.basicPlanLimitLoadFailed = false;
      this.basicPlanLimit = undefined;
      return;
    }
    // A refresh for the same user keeps the last result on screen (CU-868mbzat6). Clearing it
    // removes the jAIne chat bot, and the rebuilt chat bot loads a second jAIne widget.
    const key = `${org}:${user.id}`;
    const keepCurrent = key === this.basicPlanLimitKey && !!this.basicPlanLimit;
    this.basicPlanLimitKey = key;
    if (!keepCurrent) {
      this.basicPlanLimitLoaded = false;
      this.basicPlanLimitLoadFailed = false;
      this.jaineAllowedOnError = false;
      this.basicPlanLimitRetryVisible = false;
      this.basicPlanLimit = undefined;
    }
    this.basicPlanLimits.get(org, user.id, this.entitlementTaxYear, undefined, forceRefresh)
      .pipe(
        retry({count: 2, delay: 1000}),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: entitlement => {
          if (loadSequence !== this.entitlementLoadSequence) {
            return;
          }
          this.basicPlanLimit = entitlement;
          this.basicPlanLimitLoaded = true;
          this.basicPlanLimitLoadFailed = false;
        },
        error: error => {
          if (loadSequence !== this.entitlementLoadSequence) {
            return;
          }
          if (keepCurrent) {
            // The last good result stays. The next refresh tries again.
            return;
          }
          this.basicPlanLimit = undefined;
          this.basicPlanLimitLoaded = true;
          this.basicPlanLimitLoadFailed = true;
          this.jaineAllowedOnError = this.basicPlanLimits.featuresAllowedOnError(error);
          this.basicPlanLimitRetryVisible = this.basicPlanLimits.isBasicSessionPlan();
        }
      });
  }

  retryBasicPlanLimit(): void {
    this.loadBasicPlanLimit(true);
  }

  setupPendoRouterTracking(): void {
    // Track route changes for SPA navigation
    this.routerSubscription = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      this.isChromelessRoute = event.urlAfterRedirects.startsWith('/choose-platform');
      if (typeof pendo !== 'undefined' && pendo.isReady && pendo.isReady()) {
        pendo.pageLoad();
      }
    });
    // Initialize from current URL too — NavigationEnd already fired before
    // this subscription was set up on a fresh load directly to /choose-platform.
    this.isChromelessRoute = this._router.url.startsWith('/choose-platform');
  }

  toggleOffCanvasMenu(){
    this.titleCSS = {
      'expanded-top-nav-arrows': false,
      'shrink-top-nav-arrows': true,
      'more-expanded-top-nav-arrows': false,
      'header-taxplan-logo': true
    };
    this.isOffCanvasMenuExpanded = !this.isOffCanvasMenuExpanded;
    this.isSideMenuExpanded = this.isOffCanvasMenuExpanded;
    this.switchBoard.onOffCanvasMenuExpand.next(this.isOffCanvasMenuExpanded);
  }

  ngOnDestroy() {
    if (this.pageThemeSubscriber){
      this.pageThemeSubscriber.unsubscribe();
    }

    if (this.billingDetailsSubscriber) {
      this.billingDetailsSubscriber.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    // CU-868m49jqy: the refresh timer was only ever cleared in loggedOut().
    clearInterval(this.refreshInterval);

    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleLoader(toggle){
    // Defer to next macrotask to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.isLoading = toggle;
      this.isOverlay = toggle;
    });
  }

  updatePageTitle(title) {
    // Defer to next macrotask to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.pageTitle = title;
    });
  }

  updatePageTheme(theme) {
    this.theme = theme;
  }

  showPrevious(){
    this.switchBoard.onClickPrev.next({});
  }

  goToDefaultPage(){
    if (this.hasLoggedIn) {
      if (this.user && this.user.isCustomer) {
        this._router.navigate(['tax-planning/customer/dashboard']);
      } else {
        const orgTermsData = Session.getTaxPlanOrgTerms() || {};
        const accessInfo: any = Session.getUserAccessInfo();
        if (!orgTermsData.termsAccepted) {
          this.hasLoggedIn = false;
          this._router.navigate(['tax-planning/terms']);
        } else if (accessInfo && accessInfo.subscriptionStatus === 'Suspended'){
           this.hasLoggedIn = false;
           this._router.navigate(['tax-planning/manage-billing']);
          return;
        } else {
          this.switchBoard.onLogin.next(Session.get('user'));
          const base = this;
          console.log(this.route.url);
        }
      }
    }else{
      const link = ['/login'];
      this._router.navigate(link);
    }
  }
  redirectToPage(routeName){
    this._router.navigate(routeName);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.appWindows && !this.appWindows.nativeElement.contains(event.target)){
      this.winndowsComponent.minimizeAllWindows();
    }
  }

  displayArrows() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      return true;
    }else{
      return false;
    }
  }

  getUserSubscriptionAccessList(userId, org) {
    this.taxPlanningService.getSubscriptionStatus(org, userId).subscribe(response => {
      let obj = {
        clientPortalAccess: false,
        dashboardAccess: false,
        subscriptionStatus: response.subscriptionStatus,
        productAccess: response.productAccess
      };
      if (response.accessList && response.accessList.length > 0) {
        obj = {...obj, dashboardAccess: response.accessList.indexOf('Dashboard') !== -1, clientPortalAccess: response.accessList.indexOf('Client Portal') !== -1};
      }
      Session.setUserAccessInfo(obj);
    }, error =>  {
      this._toastService.pop(TOAST_TYPE.error, 'Failed to get subscription status');
    });
  }

  updateSessionDetails(obj){
    Session.put('user', obj);
    Session.setCurrentCompanyCurrency('USD');
    Session.setCurrentCompany(obj.default_company.id);
    if (Session.get('user').tempPassword){
      this._router.navigate(['activate']);
    } else {
      this.loadingService.triggerLoadingEvent(true);
      this.getUserSubscriptionAccessList(obj.id, obj.org);
      this.taxPlanningService.getTermsAndConditions(obj.org, obj.org.id).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.taxPlanningTerms = response || {};
        Session.setTaxPlanOrgTerms(response);
        const accessInfo: any = Session.getUserAccessInfo();
        if (!this.taxPlanningTerms.termsAccepted) {
          this._router.navigate(['tax-planning/terms']);
          return;
        } else if (accessInfo && accessInfo.subscriptionStatus === 'Suspended'){
          this.hasLoggedIn = false;
          this._router.navigate(['tax-planning/manage-billing']);
          return;
        } else {
          this.switchBoard.onLogin.next(Session.get('user'));
          const base = this;
          const route = {
            type: 'taxPlanningHome',
            route: 'tpiq/dashboard',
            clearAllStates: true
          };
          setTimeout(() => {
            base.switchBoard.onWallTpiqSwitch.next(route);
          });
        }
      });
    }
  }

  onLogoClick() {
    // 868k0rxvz: reverse app-switch (legacy Tax Planning -> Tax Projections).
    // Send the advisor to the platform picker (the same landing where they
    // choose Tax Planning vs Tax Projections after login); picking Tax
    // Projections runs the existing handoff-to-projections SSO. Using the
    // picker is the ticket's sanctioned alternative and keeps this robust to
    // the legacy prod API-Gateway /handoff allowlist gap that breaks a direct
    // handoff. Client-portal users have no second app, so the logo is a no-op.
    // Guard on this.user?.isCustomer (the restored user object), NOT the
    // this.isCustomer field: that field is only set in loggedIn() and stays
    // false on the session-restore path (constructor lines 119-126), which
    // would wrongly let a refreshed customer navigate. (CodeRabbit, PR #641.)
    if (this.user?.isCustomer) {
      return;
    }
    // Only a firm with Tax Projections access can use the picker. For other firms the
    // Tax Projections card gets a 403, and the interceptor logs the user out.
    if (!this.logoOpensPicker) {
      return;
    }
    this._router.navigate(['/choose-platform']);
  }

  /** Reads Tax Projections access from the session, the same value the login picker uses. */
  private refreshLogoAccess(): void {
    this.logoOpensPicker = !Session.getUser()?.isCustomer
      && canOpenPlatformPicker(Session.getUserAccessInfo()?.productAccess);
  }

  initializePendo(): void {
    // Wait for Pendo to be fully loaded
    const initPendo = () => {
      try {
        const user = Session.getUser();
        const org = Session.getOrg();
        const accessInfo = Session.getUserAccessInfo();
        const vendorId = Session.getVendor();

        if (!user || !user.id || !org) {
          console.warn('Pendo: User or organization data not available');
          return;
        }

        // Build visitor object with all available metadata
        const visitorData: any = {
          // Required field
          id: user.id,

          // Common fields
          full_name: user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim(),
          first_name: user.firstName || user.first_name,
          last_name: user.lastName || user.last_name,

          // User metadata
          phone_number: user.phone_number,
          is_active: user.active,
          is_admin: user.isAdmin,
          is_customer: user.isCustomer,
          org_country_code: user.orgCountryCode,
          time_zone: user.timeZone,
          onboarding_status: user.onboardingStatus,

          // Array fields (convert to comma-separated strings)
          groups: user.groups ? user.groups.join(',') : '',
          group_invitations: user.group_invitations ? user.group_invitations.join(',') : '',

          // Additional metadata
          vendor_id: vendorId
        };

        // Add access info if available
        if (accessInfo) {
          visitorData.client_portal_access = accessInfo.clientPortalAccess;
          visitorData.dashboard_access = accessInfo.dashboardAccess;
          visitorData.subscription_status = accessInfo.subscriptionStatus;
        }

        // Build account object
        const accountData: any = {
          id: org
        };

        // Initialize Pendo
        pendo.initialize({
          visitor: visitorData,
          account: accountData
        });

        console.log('Pendo initialized successfully');
      } catch (error) {
        console.error('Failed to initialize Pendo:', error);
      }
    };

    // Check if Pendo is loaded, if not wait for it
    if (typeof pendo !== 'undefined' && pendo.initialize) {
      initPendo();
    } else {
      // Wait for Pendo to load (max 10 seconds)
      let attempts = 0;
      const maxAttempts = 100;
      const checkPendoLoaded = setInterval(() => {
        attempts++;
        if (typeof pendo !== 'undefined' && pendo.initialize) {
          clearInterval(checkPendoLoaded);
          initPendo();
        } else if (attempts >= maxAttempts) {
          clearInterval(checkPendoLoaded);
          console.error('Pendo failed to load after 10 seconds');
        }
      }, 100);
    }
  }

  toggleCSS() {
    this.mainCanvasCss = {
      'main-canvas': true,
      expanded: true,
      shrinkRight: false,
      'more-expanded': false,
      'tp-firm-expanded': false
    };

    this.titleCSS = {
      'expanded-top-nav-arrows': true,
      'shrink-top-nav-arrows': false,
      'more-expanded-top-nav-arrows': false,
      'header-taxplan-logo': true
    };
  }}
